
const VERSION_DATA_CENTER = "base-platform/v2"

// 我的申请-获取权限接口
export const getRepairPermission = {
    url: `/${VERSION_DATA_CENTER}/repair/permission`,
}

// 我的申请-列表接口
export const getApplyList = {
    url: `/${VERSION_DATA_CENTER}/workflow/my/pending/list`,
    method: "POST",
}

// 我的申请-列表接口
export const getApplyRevoke = {
    url: `/${VERSION_DATA_CENTER}/repair/revoke/apply`,
}

// 我的申请-添加报修接口
export const postRepairAdd = {
    url: `/${VERSION_DATA_CENTER}/repair/add`,
    method: "POST",
}

// 我的审批-审批接口
export const getAuditList = {
    url: `/${VERSION_DATA_CENTER}/workflow/my/pending/list`,
    method: "POST",
}

// 我的审批-拒绝或同意接口
export const approveResult = {
    url: `/${VERSION_DATA_CENTER}/repair/update/status`,
    method: "POST",
}


// 报修记录、我的维修-列表接口
export const getRecordList = {
    url: `/${VERSION_DATA_CENTER}/repair/app/list`,
}

// 我的维修-维修人列表
export const getRecordUserSelect = {
    url: `/${VERSION_DATA_CENTER}/repair/user/select`,
}

// 我的维修-分配维修人接口
export const postRepairDistribute = {
    url: `/${VERSION_DATA_CENTER}/repair/distribute`,
    method: "POST",
}

// 我的维修-详情-维修反馈图片上传
export const commonSingleFileUploadOss = {
    url: `/${VERSION_DATA_CENTER}/base/common/single/file/upload/oss`,
    method: "POST",
}

// 我的维修-详情-维修反馈信息提交
export const postRepairFeedbackAdd = {
    url: `/${VERSION_DATA_CENTER}/repair/back/add`,
    method: "POST",
}


// -------------公共的接口-------------
// 我的申请、我的审批、报修记录、我的维修-详情接口 ${id}
export const getRecordDetail = {
    url: `/${VERSION_DATA_CENTER}/repair/detail`,
}

// 我的申请、我的审批、报修记录、我的维修-详情接口 ${id}
export const getDictionaryList = {
    url: `/${VERSION_DATA_CENTER}/base/dictionary/list`,
}